import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class StandaloneDetectorsDto extends InspectionCase {
  item_15_1?: InspectionCase;
  item_15_2?: InspectionCase;
  item_15_3?: InspectionCase;
  item_15_4?: InspectionCase;
  item_15_5?: InspectionValueCase;
  item_15_6_1?: InspectionCase;
  item_15_6_2?: InspectionCase;
  item_15_6_3?: InspectionCase;
}

export class StandaloneDetectors extends StandaloneDetectorsDto {
  constructor(
    data: StandaloneDetectorsDto = { title: 'התקנה, גלאים עצמאיים' }
  ) {
    super(data);
    this.item_15_1 = new InspectionCase({
      ...data.item_15_1,
      title: `הגלאים מאושרים לפי תקן ישראלי 1220 חלק 5.`
    });
    this.item_15_2 = new InspectionCase({
      ...data.item_15_2,
      title: `הגלאים מוזנים ממתח רשת ובעל סוללת גיבוי.`
    });
    this.item_15_3 = new InspectionCase({
      ...data.item_15_3,
      title: `חיבור הגלאי למתח הזינה מסופק מענף / מעגל חשמלי נפרד או מחובר למעגל מתח תאורה.`
    });
    this.item_15_4 = new InspectionCase({
      ...data.item_15_4,
      title: `התקנת הגלאי וחיבורו למתח הסינה נעשת ע"י חשמלאי מוסמך ובהתאם להוראות היצרן.`
    });
    this.item_15_5 = new InspectionValueCase({
      ...data.item_15_5,
      title: `מיקום התקנת הגלאים העצמאיים ,בהתאם להוראות נציב 550. `
    });
    this.item_15_6_1 = new InspectionCase({
      ...data.item_15_6_1,
      title: `נבדקה תקינות מנורות חיווי ע"ג הגלאי`
    });
    this.item_15_6_2 = new InspectionCase({
      ...data.item_15_6_2,
      title: `נבדק בקרת הגלאי ע"י תינוק סוללה / ניתוק מקור מתח`
    });
    this.item_15_6_3 = new InspectionCase({
      ...data.item_15_6_3,
      title: `הגלאים נבדקו בבדיקת ההפעלה ע"י לחיצה על מפסק בדיקה שע"ג הגלאי / באמצעות התזת גז על הגלאי`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_15_1.isApplicable || this.item_15_1.isPassed) &&
        (!this.item_15_2.isApplicable || this.item_15_2.isPassed) &&
        (!this.item_15_3.isApplicable || this.item_15_3.isPassed) &&
        (!this.item_15_4.isApplicable || this.item_15_4.isPassed) &&
        (!this.item_15_5.isApplicable || this.item_15_5.isPassed) &&
        (!this.item_15_6_1.isApplicable || this.item_15_6_1.isPassed) &&
        (!this.item_15_6_2.isApplicable || this.item_15_6_2.isPassed) &&
        (!this.item_15_6_3.isApplicable || this.item_15_6_3.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_15_1.getNotes(),
      ...this.item_15_2.getNotes(),
      ...this.item_15_3.getNotes(),
      ...this.item_15_4.getNotes(),
      ...this.item_15_5.getNotes(),
      ...this.item_15_6_1.getNotes(),
      ...this.item_15_6_2.getNotes(),
      ...this.item_15_6_3.getNotes()
    ];
  }
}
